module.exports = __webpack_public_path__ + "static/media/food.387dd73b.png";